'use client';
import { ChartsProvider } from '../ChartsProvider';

/**
 * @deprecated Use `ChartsProvider` instead. We added S to the charts prefix to align with other components.
 */
export const ChartProvider = ChartsProvider;
